module.exports = __webpack_public_path__ + "media/images/emblems/Manno-coat_of_arms-e1abaad43cce56e8eb208bc67f1dbcbb.svg";